import React, { FC } from 'react'
import { HStack, Typography, VStack, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import { Box } from '@mantine/core'
import Notification = App.Models.Notification

const AgentCommentOnVisitorLeadNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification }) => {
  return (
    <VStack
      onClick={() => {
        router.visit('/b2b/visitor-leads/' + notification.data.lead_id)
      }}
    >
      <HStack
        spacing="3px"
        style={{
          flexWrap: 'wrap',
          cursor: 'pointer',
          padding: '6px 12px',
        }}
      >
        <Typography variant="body-small" color={XelaColor.Gray6}>
          Agent
        </Typography>
        <Typography variant="body-small" color={XelaColor.Pink3}>
          {notification.data.event_by}
        </Typography>
        <Typography variant="body-small" color={XelaColor.Gray6}>
          comment on a visitor lead
        </Typography>
        <Typography variant="body-small-bold" color={XelaColor.Orange3}>
          #{notification.data.lead_name}
        </Typography>
      </HStack>
      <HStack spacing="12px" height="100%" style={{ padding: '6px 12px' }}>
        <Box
          style={{
            width: '8px',
            height: '30px',
            backgroundColor: XelaColor.Blue3,
            borderRadius: '4px',
          }}
        ></Box>
        <HStack
          spacing="3px"
          style={{
            flexWrap: 'wrap',
            cursor: 'pointer',
          }}
        >
          <VStack>
            <Typography variant="caption" color={XelaColor.Gray6}>
              {notification.data.comment}
            </Typography>
          </VStack>
        </HStack>
      </HStack>
    </VStack>
  )
}

export default AgentCommentOnVisitorLeadNotification
